import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { PopupToasterService } from '../services/popup-toaster.service';

@Injectable()
export class ToastInterceptor implements HttpInterceptor {
  constructor(private toastService: PopupToasterService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const toastmessage =
      req.method === 'GET' || req.method === 'OPTIONS'
        ? null
        : req.headers.has('x-ats-suppress-message')
          ? null
          : req.headers.has('x-ats-success')
            ? req.headers.get('x-ats-success')
            : $localize`Operation successful`;

    return next.handle(req).pipe(
      tap((resp) => {
        if (resp instanceof HttpResponse && toastmessage !== null) {
          this.toastService.success(
            $localize`Success`,
            decodeURIComponent(toastmessage)
          );
        }
      })
    );
  }
}

@Injectable()
export class ToastEncodeInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    let updatedRequest = req;

    if (req.headers.has('x-ats-success')) {
      updatedRequest = req.clone({
        setHeaders: {
          'x-ats-success': encodeURIComponent(
            req.headers.get('x-ats-success') ?? ''
          )
        }
      });
    }

    return next.handle(updatedRequest);
  }
}

// @Injectable()
// export class ToastEncodeInterceptor implements HttpInterceptor {
//   constructor() {}

//   intercept(
//     req: HttpRequest<any>,
//     next: HttpHandler
//   ): Observable<HttpEvent<unknown>> {
//     let updatedRequest = req;

//     if (req.headers.has('x-ats-success')) {
//       updatedRequest = req.clone({
//         headers: req.headers.set(
//           'x-ats-success',
//           encodeURIComponent(req.headers.get('x-ats-success') ?? '')
//         )
//       });
//     }

//     return next.handle(updatedRequest);
//   }
// }
